// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Icons from "../Assets/icons/Icons"
import DateInput from "../components/Reuseables/DateInput/Date"
import Dropdown from "../components/Reuseables/Dropdown/Dropdown"
import ImageUploader from "../components/Reuseables/Imageupload/imageUpload"
import Single from "../components/Reuseables/Imageupload/Single"
import NumberInput from "../components/Reuseables/Input/NumberInput"
// import RequirementsInput from "../components/Reuseables/Input/Outline"
// import Outline from "../components/Reuseables/Input/Outline"
import TextArea from "../components/Reuseables/Input/TextArea"
import TextInput from "../components/Reuseables/Input/TextInput"
import RichText from "../components/Reuseables/Quill/RichText"
// import { faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import PasswordInput from "../components/Reuseables/Input/Password"

export const lorem = "Working at Lexrae Support isn’t just a job, it’s a chance to make a real impact. We’re always looking for kind, dedicated people who share our passion for care and want to help others live fuller, happier lives. If you’re driven, compassionate, and ready to grow, we’d love to hear from you."

export const lorem2 = "Welcome to the Lexrae Blog, your go-to space for insights, updates, and stories that matter. Here, we share useful tips, industry news, and inspiring moments from our work in care. Whether you're a family member, professional, or just curious about what we do, you'll find something here to keep you informed and connected."

export const contactNumber = "01902912899"

export const validate = (formData, resume,setResumeError, setErrors) => {
    const newErrors = {};
    if (!formData?.firstName.trim()) newErrors.firstName = 'First name is required';
    if (!formData?.lastName.trim()) newErrors.lastName = 'Last name is required';
    if (!formData?.email.trim()) newErrors.email = 'Email is required';
    if (!formData?.telephone.trim()) newErrors.telephone = 'Phone number is required';
    if (!formData?.coverLetter.trim()) newErrors.coverLetter = 'Cover letter is required';
    if (!resume) setResumeError(true);
    else setResumeError(false);

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0 && resume;
  };

export const social = [
  {
    name: "linkedin",
    link: "https://www.linkedin.com/company/lexrae-support/",
    icon: Icons.linkedIn,
    id: 1
  },
  {
    link: "https://www.instagram.com/lexraesupport?igsh=MWw0aG90d2NpdG1rOA==",
    name: "instagram",
    icon: Icons.instagram,
    id: 2,
  },
  {
    name: "twitter",
    link: "https://twitter.com/LexraeSupport?s=20&t=1NNA6cKJdv2b0a3d4j5H8g",
    icon: Icons.twitter,
    id: 3
  },
  {
    link: "https://www.facebook.com/LexraeSupport",
    name: "facebook",
    icon: Icons.facebook,
    id: 4,
  },
]


export const service = [
  { id: 1,
    title: "Supported Living",
    detail: "We provide safe, comfortable homes where individuals can grow in confidence and independence, while still getting the care they need, every step of the way. Our supported living services are built around the unique needs of each person, offering flexibility, structure, and a real sense of belonging. We encourage choice, independence, and personal growth in a setting that feels like home."
  },

  { id: 2,
    title: "Respite",
    detail: "Whether it’s a short break for a loved one or a moment to recharge, our respite care offers peace of mind with high-quality support in a friendly, welcoming environment. We understand how important it is for families and carers to rest without worry, knowing their loved ones are in capable, compassionate hands. Every stay is tailored, safe, and as enriching as possible."
  },

  { id: 3,
    title: "Complex Care",
    detail: "For individuals with more advanced needs, our trained team delivers specialised care with compassion, skill, and dignity, ensuring no detail is overlooked. From clinical support to daily personal care, we work closely with healthcare professionals and families to provide a seamless and holistic approach. Our aim is always to support quality of life, no matter how complex the need."
  },

  { id: 4,
    title: "Day Center",
    detail: "Our Day Centre offers a vibrant, supportive space where individuals can connect, learn, and enjoy meaningful activities. From creative sessions and skill-building workshops to group outings and social events, every day is designed to spark joy, confidence, and a sense of purpose. It’s more than just care, it’s a space to thrive."
  }
]

export const colors = [
  " #F8F7F7", "#F5EEEE", "#F8FCDF","#EBF5FF"
]

export const headert = `At Lexrae Support, we’re more than a care provider,
we’re a team of passionate people on a mission to make a real difference.
Built on trust, empathy, and professionalism, we deliver tailored support that puts individuals first.
Whether it’s supported living, respite, or complex care, we walk alongside every person we support with dignity,
respect, and genuine compassion.
`
  export const tableHeader = {
    title: "Title",
    date_posted: "Date Posted",
    author: "Author",
    status: "Status",
    createdAt: "Date Created",
    password: "password",
    username: "username",
    role: "role"
  }


  export const tableBody = {
    title: "title",
    date_posted: "createdAt",
    author: "author",
    status: "status",
    username: "username",
    role: "role",
    createdAt: "createdAt",
  } 

export const label = {
  title: "Title",
  author: "Author",
  image: "Image",
  text: "Content",
  content: "Content",
  salary: "Pay",
  amount: "Amount",
  requirements: "Requirments",
  employmentType: "Employment",
  hoursPerWeek: "Hours Per Week",
  location: "Location",
  jobDescription: "Job Description",
  whyChooseUs: "Why Choose Us",
  deadline: "Deadline",
  status: "Status",
  username: "username",
  password: "password",
  confirm_password: "confirm password",
  role: "Role"
}

export const inputTypes = {
  jobDescription: "textArea",
  whyChooseUs: "textArea",
  galleryImages: "media",
  image: "image",
  coverImage: "image",
  text: "textArea",
  amount: "number",
  content: "textArea",
  deadline: "date",
  location: "dropdown",
  status: "dropdown",
  salary: "dropdown",
  employmentType: "dropdown",
  role: "dropdown",
  password: "password",
  confirm_password: "password",
}

export const DropdownOptions = {
  status: ["active", "close"],
  salary: ["wages", "salary"],
  employmentType: ["Full-Time", "Part-Time", "Bank"],
  location: ["Shrewsbury", "Telford"],
  role: [ "media","hr" ]
}

export const placeholder = {

}

export const switchInput = (
  e, 
  handleRemoveImage, 
  handleCancel,
  handleImageUpload, 
  className, 
  formData,
  handleChange,
  multiplePreview, 
  setMultiplePreview,
  singlePreview,
  setSinglePreview,
  show,
  setShow
    ) => {
  switch (inputTypes[e]) {
    case "textArea":
  if (
    e === "jobDescription" ||
    e === "whyChooseUs" ||
    e === "text" ||
    e === "content"
  ) {
      return (
      <RichText
        value={formData[e]}
        onChange={(value) =>
          handleChange({ target: { name: e, value } })
        }
        label={label[e]}
        name={e}
      />
    );
  }

  return (
    <TextArea
      title={label[e]}
      name={e}
      id={e}
      value={formData[e]}
      className={className}
      onChange = {handleChange}
    />
  )


      case "media": 
      return (
        <div>
          <ImageUploader
            multiplePreview={multiplePreview}
            setMultiplePreview={setMultiplePreview}
            handleImageUpload={handleImageUpload}
            handleCancel={handleCancel}
          /> 
        </div>
      )

      case "image":
        return (
          <Single
            handleChange={handleChange}
            singlePreview={singlePreview}
            setSinglePreview={setSinglePreview}
            handleRemoveImage={handleRemoveImage}
            e={e}
          />
        );


      case "date": 
      return (
        <DateInput
          label={label[e]}
          value={formData[e]}
          onChange={handleChange}
          name={e}
          className={className}
        />
      )

      case "dropdown": 
      return (
        <Dropdown 
          onChange={handleChange}
          value={formData[e]}
          label={label[e]}
          name={e}
          options={DropdownOptions[e]}
          placeholder={placeholder[e]}
          className={className}
        />
      )

      case "number" : 
      return (
        <NumberInput 
          title={label[e]}
          name={e}
          id={e}
          value={formData[e]}
          className={className}
          onChange={handleChange}
        />
      )

      case "password": 
      return (
        <PasswordInput 
          title={label[e]}
          name={e}
          id={e}
          value={formData[e]}
          className={className}
          onChange={handleChange}
          show={show}
          setShow={setShow}
        />  
      )
  
    default:
      return (
        <TextInput 
        title={label[e]}
        name={e}
        id={e}
        value={formData[e]}
        className={className}
        onChange={handleChange}
      />
      )
  }
}

const excludedKeys = [
  "_id",
  "createdAt",
  "updatedAt",
  "jobPreference",
  "jobStartDate",
  "nameOfCareHome",
  "applicationCount",
  "hoursPerWeek",
  "requirements",
  "date",
  "__v",
  "author",
  "employees"
];

export const filterFormKeys = (formData) => {
  return Object.keys(formData).filter((key) => !excludedKeys.includes(key));
};

export const formatDate = (isoString) => {
  const date = new Date(isoString);

  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString(undefined, options);
}